import { Exercise } from '../types/Exercises';

export const exerciseToAnswerString = (exercise: Exercise): string =>
    `${exercise.answer.value} ${exercise.answer.units[0]}`;
